<template>
  <div class="block-agreement agreement modal">
    <div class="blacking" @click="hideSelf"></div>
    <div class="agreement__container">
      <img
          src="../images/utils/close-black.svg"
          alt="Закрыть"
          class="agreement__close"
          @click="hideSelf"
      />
      <div class="agreement__content" v-html="disclaimer">
        <!--        <h3 class="agreement__title">-->
        <!--          ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ <br />-->
        <!--          в редакции от «1» июня 2021 г.-->
        <!--        </h3>-->
        <!--        <div class="agreement__paragraph"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
import disclaimer from "@/common/disclaimer.js";

export default {
  name: "full-agreement",
  data(){
    return{
      disclaimer,
    }
  },
  methods: {
    hideSelf() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.agreement {
  &__container {
    width: 90vw;
    height: 90vh;
    top: 5vh;
    left: 5vw;
    position: fixed;
    z-index: 1200;
    background: #fff;
    padding: 40px 0px 20px 20px;
    cursor: default;
  }

  &__content {
    font-size: 14px;
    overflow: auto;
    max-height: 100%;

    ::v-deep h3 {
      font-size: 16px;
    }
    ::v-deep p{
      font-size: 14px;
    }
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
  }

  &__paragraph {
    margin-bottom: 10px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  &__close {
    position: absolute;
    right: 30px;
    top: 20px;
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
}

@media (max-width: 640px) {
  .agreement {
    &__container {
      padding: 15px;
      padding-top: 25px;
    }

    &__content {
      ::v-deep h3 {
        font-size: 12px;
      }

      ::v-deep p {
        font-size: 10px;
      }
    }

    &__close {
      width: 12px;
      right: 10px;
      top: 10px;
    }
  }
}
</style>
